module.exports = __webpack_public_path__ + "static/fonts/Arita-buriB.d2902f0.eot";